import { fetch } from '@/api/index'
import { getToken, removeToken, removeLocale, getProjectTargetStr, removeProjectTargetStr } from '@/utils/auth'
import router, { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    loginUserInfo: {}, // 当前登录用户信息
    token: getToken(),
    userId: '',
    name: '',
    currentOrgId: '', // 当前组织ID
    currentOrgName: '', // 当前组织名称
    rootStatus: '', // 是否系统管理员 1 是 其它值不是
    avatar: {
      prefixUrl: '',
      serviceFileName: ''
    },
    locale: '',
    roleName: '',
    roleId: '', // 当前用户角色
    roleList: [], // 当前用户可选角色
    objProjectTarget: {} // 当前账户的项目列表
  }
}

const state = getDefaultState()

const getters = {}

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_LOGIN_USER_INFO(state, obj) {
    state.loginUserInfo = obj
  },
  SET_USERID: (state, userId) => {
    state.userId = userId
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_CURRENTORGID: (state, name) => {
    state.currentOrgId = name
  },
  SET_CURRENTORGNAME: (state, val) => {
    state.currentOrgName = val
  },
  SET_ROOTSTATUS: (state, name) => {
    state.rootStatus = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_LOCALE(state, value) {
    state.locale = value
  },
  SET_ROLE_NAME(state, value) {
    state.roleName = value
  },
  SET_ROLE_ID(state, value) {
    state.roleId = value
  },
  SET_ROLE_LIST(state, value) {
    state.roleList = value
  },
  SET_OBJ_PROJECT_TARGET(state, value) {
    state.objProjectTarget = value
  }
}

const actions = {
  // get user info
  getInfo({ commit }) {
    return new Promise(async (resolve, reject) => {
      const data = await fetch('/api/park/getCurrentUserInfo', {}, 'get')

      if (data.code === 20000 && Object.prototype.toString.call(data.data) === '[object Object]') {
        const {
          parkUserId,
          userName,
          avatar,
          currentOrgId,
          currentOrgName,
          currentParkAdminStatus
        } = data.data

        commit('SET_USERID', parkUserId)
        commit('SET_NAME', userName)
        commit('SET_AVATAR', avatar)
        commit('SET_CURRENTORGID', currentOrgId)
        commit('SET_CURRENTORGNAME', currentOrgName)
        commit('SET_ROOTSTATUS', currentParkAdminStatus)
        commit('SET_LOGIN_USER_INFO', data.data)

        resolve(data.data)
      } else {
        reject('error')
      }
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      removeToken() // must remove  token  first
      removeLocale()
      removeProjectTargetStr()
      resetRouter()
      commit('RESET_STATE')
      dispatch('tagsView/delAllViews', null, { root: true })

      resolve()
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken() // must remove  token  first
      removeLocale()
      removeProjectTargetStr()
      commit('RESET_STATE')
      resolve()
    })
  },
  // 角色切换
  async changeUserDefaultRole({ commit, dispatch }, id) {
    const data = await fetch('/api/user/user/changeUserDefaultRole', { id }, 'get')
    if (data.code === 20000) {
      // 重置路由、清空tagsView
      resetRouter()
      commit('RESET_STATE')
      dispatch('tagsView/delAllViews', null, { root: true })

      setTimeout(() => {
        location.replace(`/${process.env.PLATFORM_ENV}`)
      }, 300)
    }
  },
  // 获取当前账户的项目列表
  async getProjectTargetList({ commit }) {
    const data = await fetch('/api/user/project/getProjectTargetList', {}, 'get')
    if (data.code === 20000) {
      commit('SET_OBJ_PROJECT_TARGET', Object.prototype.toString.call(data.data) === '[object Object]' ? data.data : {})
    }
  },
  // 园区切换
  async changeCurrentUserManagePark({ commit, dispatch }, id) {
    const data = await fetch('/api/park/changeCurrentUserManagePark', {
      parkId: id
    }, 'get')
    if (data.code === 20000) {
      // 重置路由、清空tagsView
      resetRouter()
      commit('RESET_STATE')
      dispatch('tagsView/delAllViews', null, { root: true })

      setTimeout(() => {
        location.replace(`/${process.env.PLATFORM_ENV}`)
      }, 300)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

